module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('aside', {
    staticClass: "main-sidebar",
    attrs: {
      "id": "slider"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, _vm._l((_vm.slideMenuItems), function(item, index) {
    return _c('va-slide-orange-item', {
      key: index,
      attrs: {
        "data": item,
        "type": item.type,
        "isHeader": item.isHeader,
        "icon": item.icon,
        "name": item.name,
        "badge": item.badge,
        "items": item.items,
        "router": item.router,
        "link": item.link
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "logout"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "menu-logout"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Logout'
      }
    }
  }, [_c('div', [_c('img', {
    staticClass: "logout-icon"
  })]), _vm._v(" "), _c('span', {
    staticClass: "side-parent"
  }, [_vm._v("Cerrar Sesión")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "close-slider"
  }, [_c('img', {
    staticClass: "ico-close",
    attrs: {
      "src": "/static/img/svg/close.svg"
    },
    on: {
      "click": function($event) {
        return _vm.closeSlider()
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "logo-icon",
    attrs: {
      "src": "/static/img/icons/ic_dinet_logo.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e5c9fb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/SliderOrange.vue
// module id = 505
// module chunks = 1